module.exports = __webpack_public_path__ + "img/main3.18e14425.png";